/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".callout_23df380a .ms-Suggestions-itemButton{padding:0;border:none}.callout_23df380a .ms-Suggestions{min-width:300px}" }]);
export var callout = "callout_23df380a";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map